import { _ as _async_to_generator } from "@swc/helpers/_/_async_to_generator";
import { _ as _ts_generator } from "@swc/helpers/_/_ts_generator";
import { RetailerStore } from "@faire/retailer-visitor-shared/stores/domain/RetailerStore";
import { trackEvent } from "@faire/web--source/common/trackEvent";
export var trackRetailerEvent = /*#__PURE__*/ function() {
    var _ref = _async_to_generator(function(event) {
        var retailerToken, events;
        return _ts_generator(this, function(_state) {
            retailerToken = RetailerStore.get().retailerToken;
            if (retailerToken) {
                events = [
                    "/retailer/".concat(retailerToken)
                ].concat(event);
                return [
                    2,
                    trackEvent(events)
                ];
            }
            return [
                2,
                trackEvent(event)
            ];
        });
    });
    return function trackRetailerEvent(event) {
        return _ref.apply(this, arguments);
    };
}();
